import { nanoid } from "nanoid";
import { findStringBetweenMatchingBrace, getMatchesFromString, stripCommentsAndEmptyLinesFromCode } from "../../helpers/parseHelpers";
import { IModelInfo, IModelMemberInfo } from "../ModelInfos/IModelInfo";

export function parseCsharp(data: string): IModelInfo[] {
    const code = stripCommentsAndEmptyLinesFromCode(String(data));
    console.log("c# parse 1", code);
    const typesWithCode = getNamespacesAndTypesFromCode(code);

    const result: IModelInfo[] = [];
    for (const typeWithCode of typesWithCode) {
        console.log("c# parse 2", typeWithCode);
        const model = parseModelFromCode(typeWithCode);
        if (model) {
            result.push(model);
        }
    }

    console.log("c# parse 3", result);
    return result;
}

interface RelatedCode {
    typeKind: string;
    typeName: string;
    code: string;
    imports: string[];
}
function* getNamespacesAndTypesFromCode(code: string): Iterable<RelatedCode> {
    // const reNamespace = /\b(namespace)\s*?([^\s]+)/gi;
    const reUsings = /^\s*?using\s*?([^\s]+)\s*;/gmi;
    const imports = Array.from(getMatchesFromString(code, reUsings)).map(x => x[1]);

    const reClass = /\b(class|interface|struct|enum)\s*?([^\s():]+)/gi;
    for (const match of getMatchesFromString(code, reClass)) {
        console.log("found", match);
        const [value, typeKind, typeName] = match;
        const start = match.index! + value.length - 1;
        const relatedCode = findStringBetweenMatchingBrace(code, start, "{", "}");
        if (relatedCode && relatedCode.trim().length > 0) {
            yield {
                typeKind,
                typeName,
                code: relatedCode,
                imports
            };
        }
    }
}

function parseModelFromCode(typeWithCode: RelatedCode): IModelInfo | undefined {
    const { code, typeName, imports } = typeWithCode;

    const publicProps = /\bpublic\b.*?\s+?([_a-zA-Z0-9<>[\]?]+)\s+([_a-zA-Z0-9]+?)\s*[;{=]/gm;
    const fallbackProps = /\b([_a-zA-Z0-9<>[\]?]+)\s+([_a-zA-Z0-9]+?)\s*[;{=]/gm;

    let props = Array.from(getMatchesFromString(code, publicProps));
    if (props.length < 1)
        props = Array.from(getMatchesFromString(code, fallbackProps));


    const members: IModelMemberInfo[] = props.map(x => ({
        id: nanoid(),
        name: x[2],
        originalName: x[2],
        type: {
            name: x[1],
            originalName: x[1]
        }
    }));

    const model: IModelInfo = {
        id: nanoid(),
        importId: nanoid(),
        created: new Date(),
        namespace: "default",
        name: typeName,
        originalName: typeName,
        extends: [],
        imports,
        members
    };
    return model;
}
